export default __webpack_public_path__ + "static/media/SairaExtraCondensed-Medium.483493a9.ttf";